package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ifaandroid.feature.content.insights.generated.resources.Res
import ifaandroid.feature.content.insights.generated.resources.ic_clock_16
import one.healthium.insights.domain.models.HintModel
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource

@Composable
fun Hint(model: HintModel?) {
    if (model != null) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (model.iconName != null) {
                when (model.iconName) {
                    "clock" -> Icon(
                        painter = painterResource(Res.drawable.ic_clock_16),
                        contentDescription = null,
                        tint = AppTheme.colors.textInverted100,
                    )
                }
                Spacer(Modifier.width(8.dp))
            }
            Text(
                text = model.text ?: "",
                style = AppTheme.textStyles.secondary_12_700,
                color = AppTheme.colors.textInverted100,
            )
        }
    }
}